<template>
  <section class="module max-width side-padding novita">
    <h2 class="title-medium section-title">Novità</h2>
    <div class="col-4">
      <article 
        class="album-preview aos-init aos-animate" 
        data-aos="fade-up" 
        :data-aos-delay="200 * index" 
        v-for="(record, index) in novita"
        :key="record.id">

        <router-link :to="'/catalog/' + record.slug">
          <div class="album-img-block">
            <img v-if="record.cover.path" :src="record.cover.path" />
            <img v-else src="/themes/caramba/assets/images/album.jpg" />
            <svg version="1.1" class="sticker-new" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="73.891px" height="53.849px" viewBox="0 0 73.891 53.849" enable-background="new 0 0 73.891 53.849" xml:space="preserve"><ellipse fill="#FFFFFF" cx="36.945" cy="26.925" rx="36.945" ry="26.925"/><path d="M10.461,37.438c0-5.758,0-11.514,0-17.271c1.094-0.413,2.194-0.801,3.301-1.162c2.305,3.093,4.638,6.295,6.987,9.609c0-3.845,0-7.689,0-11.534c1.078-0.242,2.159-0.462,3.244-0.657c0,5.756,0,11.514,0,17.271c-1.171,0.211-2.339,0.45-3.501,0.718c-2.314-3.226-4.61-6.34-6.88-9.348c0,3.754,0,7.508,0,11.262C12.556,36.673,11.506,37.044,10.461,37.438z"/><path d="M27.707,33.114c0-5.757,0-11.514,0-17.27c4.312-0.564,8.661-0.762,12.998-0.592c0,0.973,0,1.947,0,2.922c-3.156-0.125-6.318-0.053-9.467,0.211c0,1.276,0,2.553,0,3.83c2.93-0.248,5.872-0.326,8.809-0.236c0,0.97,0,1.939,0,2.91c-2.937-0.09-5.879-0.01-8.809,0.235c0,1.567,0,3.134,0,4.7c3.261-0.273,6.536-0.34,9.802-0.199c0,0.971,0,1.941,0,2.912C36.592,32.343,32.131,32.538,27.707,33.114z"/><path d="M46.524,32.97c-1.39-5.916-2.784-11.795-4.179-17.637c1.208,0.073,2.414,0.176,3.619,0.305c0.878,4.049,1.756,8.114,2.631,12.193c1.062-3.804,2.121-7.584,3.178-11.342c1.387,0.258,2.769,0.554,4.144,0.889c1.004,4.266,2.004,8.551,3.001,12.856c0.871-3.77,1.739-7.527,2.604-11.265c1.145,0.371,2.284,0.77,3.415,1.197c-1.352,5.248-2.713,10.533-4.086,15.857c-1.208-0.381-2.426-0.731-3.647-1.051c-1.137-4.604-2.279-9.178-3.426-13.725c-1.142,4.06-2.289,8.146-3.438,12.26C49.071,33.298,47.8,33.118,46.524,32.97z"/></svg>
          </div>
            
          <h1 class="title-small regular">{{ record.artist.name }}</h1>
          <h2 class="title-small light">{{ record.title }}</h2>
          <p v-if="record.category && record.category.name != ''" class="normal arial">{{ record.category.name }}</p>
        </router-link>

      </article>

    </div>
  </section>
</template>

<script>
import axios from 'axios/dist/axios';

export default {
  name: 'Novita',
  data () {
    return {
      novita: []
    }
  },
  mounted() {
    axios.get(window.location.origin + '/api/v1/album/list?per_page=4&homepage=1')
      .then(resp => this.novita = resp.data.data);
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/vue/components/Novita.vue